import PropTypes from 'prop-types'
import styled from 'styled-components'

import {
  backgroundTypes,
  borderTypes,
  boxModelTypes,
  cssTypes,
  displayTypes,
  flexboxTypes,
} from '../types'
import { background, border, boxModel, css, display, flexbox } from '../util'

/**
 * Helper for content alignment with common short-hand properties.
 * Use flexbox properties directly for richer customisation.
 * @type {Object}
 */
const ALIGN = {
  bottom: 'align-items: flex-end',
  center: 'justify-content: center',
  left: 'justify-content: flex-start',
  middle: 'align-items: center',
  right: 'justify-content: flex-end',
  top: 'align-items: flex-start',
}

/**
 * @namespace Box
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Box = styled.div`
  ${background};
  ${border};
  ${boxModel};
  ${css};
  ${display};
  ${flexbox};
  ${({ align }) => align && ALIGN[align]};
`

/**
 * @name defaultProps
 * @memberof Box
 * @desc Primitive's default properties
 */
Box.defaultProps = {
  borderWidth: [0],
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  flexWrap: 'wrap',
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof Box
 * @desc Primitive's prop type definitions
 */
Box.propTypes = {
  ...backgroundTypes,
  ...borderTypes,
  ...boxModelTypes,
  ...cssTypes,
  ...displayTypes,
  ...flexboxTypes,
  /** Alignment */
  align: PropTypes.oneOf(Object.keys(ALIGN)),
}

/** @component */
export default Box
